import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Info: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(.72254 0 0 .72254 -27.933 -509.39)">
        <path
          // eslint-disable-next-line max-len
          d="m53.33 719.78v10.38h4.15v-10.38zm-0.24-4.23c0 1.77 1.21 2.07 2.24 2.07h0.15c1.03 0 2.24-0.3 2.24-2.07v-0.09c0-1.8-1.21-2.13-2.24-2.13h-0.15c-1.03 0-2.24 0.33-2.24 2.13zm-12.36 6.2c0-8.05 6.53-14.58 14.58-14.58s14.58 6.53 14.58 14.58-6.53 14.58-14.58 14.58-14.58-6.53-14.58-14.58z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default Info;
